/* global Swiper, clickHandler, LazyLoad */

const fullScreenImageSliderElements = document.querySelectorAll('[data-slider="fullscreen-image__slider"]');
const fullScreenImageSliderOptions = {
  direction: 'vertical',
  slidesPerView: 1,
  mousewheel: {
    releaseOnEdges: true,
  },
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
  touchReleaseOnEdges: true,
  speed: 800,
  hashNavigation: {
    watchState: true,
  },
  keyboard: {
    enabled: true,
  },
};

if (fullScreenImageSliderElements.length > 0) {
  document.body.classList.add('hide-scrollbar', 'has-custom-scrollbar');

  window.addEventListener('load', () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }, 10);
  });
}

const srollToParent = (parentElemOffset) => {
  if ((document.documentElement.scrollTop || document.body.scrollTop) > parentElemOffset) {
    clickHandler(parentElemOffset);
  }
};

const toggleBodyClass = (className, add) => {
  document.body.classList.toggle(className, add);
};

fullScreenImageSliderElements.forEach((el) => {
  const parentElem = el.closest('.sc-fullscreen-image');
  const parentElemOffset = parentElem.offsetTop;
  const fullScreenImageSlider = new Swiper(el, fullScreenImageSliderOptions);

  fullScreenImageSlider.on('slideNextTransitionStart', () => {
    toggleBodyClass('is-scrolled', true);
    toggleBodyClass('is-scrolled-up', false);
    toggleBodyClass('hide-scrollbar', true);
    srollToParent(parentElemOffset);
  });

  fullScreenImageSlider.on('slidePrevTransitionStart', () => {
    srollToParent(parentElemOffset);
    toggleBodyClass('is-scrolled-up', true);
    toggleBodyClass('is-scrolled', false);
    toggleBodyClass('hide-scrollbar', true);
  });

  fullScreenImageSlider.on('slideChange', () => {
    if (fullScreenImageSlider.isEnd) {
      setTimeout(() => {
        document.body.classList.remove('hide-scrollbar');
      }, 400);
    }
  });

  let lastScrollTop = 0;
  window.addEventListener('scroll', () => {
    const st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
      // downscroll code
      document.body.classList.remove('hide-scrollbar');
      fullScreenImageSlider.mousewheel.disable();
      fullScreenImageSlider.allowTouchMove = false;
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

    const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
    if (topOffset <= parentElemOffset) {
      fullScreenImageSlider.mousewheel.enable();
      fullScreenImageSlider.allowTouchMove = true;
    }
  });

  const lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy-video',
  });

  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});

// ##################################################
// Pageloader for homepage intro video
// ##################################################

const introVideo = document.querySelector('.fullscreen-image__video video');

if (introVideo) {
  introVideo.addEventListener('canplaythrough', () => {
    setTimeout(() => {
      document.body.classList.add('is-loaded');
    }, 250);
  });
} else {
  document.body.classList.add('is-loaded');
}
